// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.claims.RentalManagerUserClaimWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  RentalManagerUserClaimType,
  UserClaimAddResponseWebDto,
  UserClaimGetExclusivePropertiesForAllUnverifiedWebDto,
  UserClaimGetExclusivePropertiesResponseWebDto,
  UserClaimListResponseWebDto,
  UserClaimPropertyLookupAllResponseWebDto,
  UserClaimPropertyLookupResponseWebDto,
} from '../..';

interface AddParams {
  type: RentalManagerUserClaimType;
  value: string;
}
interface DeleteParams {
  type: RentalManagerUserClaimType;
  value: string;
}
interface GetExclusivePropertiesParams {
  limit?: number;
  type: RentalManagerUserClaimType;
  value: string;
}
interface GetExclusivePropertiesForAllUnverifiedParams {
  limit?: number;
}
interface PropertyLookupParams {
  limit?: number;
  type: RentalManagerUserClaimType;
  value: string;
}
interface PropertyLookupAllParams {
  includeUnverified?: boolean;
  includeVerified?: boolean;
  limit?: number;
}

export const RentalManagerUserClaimWebApiHandler_add_Path = '/api/web/v1/users/claims/add';

/**
 * Add a new contact method
 */
export const RentalManagerUserClaimWebApiHandler_add = (getParams: AddParams, client = getClient()) => {
  return httpFrontEndRequest<AddParams, never, UserClaimAddResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserClaimWebApiHandler_add_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserClaimWebApiHandler_delete_Path = '/api/web/v1/users/claims/delete';

/**
 * Delete a contact method
 */
export const RentalManagerUserClaimWebApiHandler_delete = (getParams: DeleteParams, client = getClient()) => {
  return httpFrontEndRequest<DeleteParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserClaimWebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserClaimWebApiHandler_deleteAllUnverified_Path =
  '/api/web/v1/users/claims/deleteAllUnverified';

/**
 * Delete all unverified contact methods
 */
export const RentalManagerUserClaimWebApiHandler_deleteAllUnverified = (client = getClient()) => {
  return httpFrontEndRequest<never, never, void>(
    {
      endpoint: RentalManagerUserClaimWebApiHandler_deleteAllUnverified_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserClaimWebApiHandler_getExclusiveProperties_Path =
  '/api/web/v1/users/claims/getExclusiveProperties';

/**
 * Retrieve listings that are exclusive to the given contact method
 */
export const RentalManagerUserClaimWebApiHandler_getExclusiveProperties = (
  getParams: GetExclusivePropertiesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetExclusivePropertiesParams, never, UserClaimGetExclusivePropertiesResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserClaimWebApiHandler_getExclusiveProperties_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserClaimWebApiHandler_getExclusivePropertiesForAllUnverified_Path =
  '/api/web/v1/users/claims/getExclusivePropertiesForAllUnverified';

/**
 * Retrieve listings that are exclusive to all the user's unverified contact methods
 */
export const RentalManagerUserClaimWebApiHandler_getExclusivePropertiesForAllUnverified = (
  getParams: GetExclusivePropertiesForAllUnverifiedParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    GetExclusivePropertiesForAllUnverifiedParams,
    never,
    UserClaimGetExclusivePropertiesForAllUnverifiedWebDto
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserClaimWebApiHandler_getExclusivePropertiesForAllUnverified_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserClaimWebApiHandler_list_Path = '/api/web/v1/users/claims/list';

/**
 * List all user's contact methods
 */
export const RentalManagerUserClaimWebApiHandler_list = (client = getClient()) => {
  return httpFrontEndRequest<never, never, UserClaimListResponseWebDto>(
    {
      endpoint: RentalManagerUserClaimWebApiHandler_list_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserClaimWebApiHandler_propertyLookup_Path = '/api/web/v1/users/claims/propertyLookup';

/**
 * Lookup properties by email or phone
 */
export const RentalManagerUserClaimWebApiHandler_propertyLookup = (
  getParams: PropertyLookupParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<PropertyLookupParams, never, UserClaimPropertyLookupResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserClaimWebApiHandler_propertyLookup_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserClaimWebApiHandler_propertyLookupAll_Path = '/api/web/v1/users/claims/propertyLookupAll';

/**
 * Lookup properties by all additional contact methods
 */
export const RentalManagerUserClaimWebApiHandler_propertyLookupAll = (
  getParams: PropertyLookupAllParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<PropertyLookupAllParams, never, UserClaimPropertyLookupAllResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserClaimWebApiHandler_propertyLookupAll_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
